<template>
  <div>
    <vs-row class="mb-3 mt-3">
      <h4>Dataset {{ header }}</h4>
      <vs-spacer />
      <span style="margin-right: 10px">{{ textSelect }}</span>
      <vs-icon class="ml-2" @click="showModal" icon="settings"></vs-icon>
    </vs-row>

    <div style="position: relative; width: 100%">
      <ScatterChart
        :chart="optionChart"
        :id="idgraph"
        v-if="delay == 1"
        :updated="updatechart"
      />
      <!-- <ScatterChart :chartData="datascatter" :options="option" /> -->
    </div>
    <b-modal
      id="modal-1"
      no-close-on-backdrop
      :ref="'settingChart' + header"
      hide-header-close
      centered
    >
      <template #modal-title>
        <h4 class="textSuccess">Select Date</h4>
      </template>
      <!-- {{ arrSensor }} -->
      <div class="con-exemple-prompt p-3">
        <vs-select class="selectExample" label="Options" v-model="select1">
          <vs-select-item
            :key="index"
            :value="item.value"
            :text="item.text"
            v-for="(item, index) in options1"
          />
        </vs-select>
        <div v-if="select1 === 1" class="mt-4 p-2" id="selectitem">
          <a>Duration : </a>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="4">3hr</vs-radio>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="2">6hr</vs-radio>
          <vs-radio v-model="radios_hr" class="ml-2" vs-value="1"
            >12hr</vs-radio
          >
        </div>
        <div v-if="select1 === 2" class="mt-4 p-2" id="selectitem">
          <a>Date time : </a>
          <vc-date-picker
            v-model="dateRange"
            is-range
            mode="dateTime"
            :masks="masks"
            color="green"
            @input="getTagLog"
          >
            <template v-slot="{ inputValue, inputEvents }">
              <div class="select-date ml-2">
                <div v-on="inputEvents.start" class="date-range">
                  <vs-icon icon="date_range"></vs-icon>
                  <div>
                    <span>
                      {{ inputValue.start }}
                    </span>
                    -
                    <span>
                      {{ inputValue.end }}
                    </span>
                  </div>
                </div>
              </div>
            </template>
          </vc-date-picker>
        </div>
      </div>
      <template #modal-footer="{}">
        <vs-button
          color="success"
          class="mr-2 btnBorderpop"
          @click="accept(getChartData)"
          type="filled"
          >OK</vs-button
        >
        <vs-button
          class="btnBorderpop"
          color="dark"
          @click="closeModal"
          type="flat"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
  </div>
</template>

<script>
// import Scatterchart from "./../../Dashboard/Scatterchart.vue";
import ScatterChart from "@/components/HighChart/ScatterChart.vue";
// import ScatterChart from "@/components/ChartJs/ScatterChart.js";

export default {
  props: ["header", "dataA", "idgraph", "colorgraph", "id"],
  components: { ScatterChart },
  data() {
    return {
      select1: 1,
      dateRange: {
        start: new Date(new Date().getTime() - 7 * 24 * 60 * 60 * 1000),
        end: new Date(),
      },
      radios_hr: "4",
      options1: [
        { text: "Daily", value: 1 },
        { text: "Manual", value: 2 },
      ],
      textSelect: "",
      activePrompt: false,
      activePrompt2: false,
      val: "",
      valMultipe: {
        value1: "",
        value2: "",
      },
      delay: 0,
      // chart js
      option: {
        scales: {
          xAxes: [
            {
              type: "linear",
              position: "bottom",
              scaleLabel: {
                display: true,
                labelString: "Flow Rate (L/min)",
              },
            },
          ],
          yAxes: [
            {
              // id: "A",
              ticks: {
                // beginAtZero: true,
                // fontColor: "#ffffff",
                step: 1,
              },
              // position: "left",
              scaleLabel: {
                display: true,
                labelString: "Surface Temperature (°C)",
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              console.log(tooltipItem, data);
              var label = data.datasets[tooltipItem.datasetIndex].label || "";

              if (label) {
                label += ":";
              }
              label = label + tooltipItem.value + "," + tooltipItem.label;
              return label;
            },
          },
        },
      },
      datascatter: {
        datasets: [
          {
            label: "Surface Temperature (°C),Flow Rate (L/min)",
            backgroundColor: "rgb(255, 99, 132)",
            // xAxisID:'asd',
            data: [],
          },
        ],
      },
      dataChart12hr: [],
      dataChartbytime: [],
      // highchart
      dataChart: [],
      updatechart: 0,
      optionChart: {
        chart: {
          type: "scatter",
          zoomType: "xy",
          backgroundColor: "transparent",
        },
        title: {
          text: "Surface Temp, Flow Rate ",
          style: {
            fontSize: "0px",
          },
        },
        xAxis: {
          title: {
            enabled: true,
            text: "Flow Rate (L/min)",
          },
          startOnTick: true,
          endOnTick: true,
          showLastLabel: true,
          // min:0,
        },
        yAxis: {
          title: {
            text: "Surface Temperature (°C)",
          },
          align: "left",
        },
        legend: {
          layout: "vertical",
          align: "left",
          verticalAlign: "top",
          x: 100,
          y: 70,
          floating: true,
          backgroundColor: "#fff",
          // backgroundColor: Highcharts.defaultOptions.chart.backgroundColor,
          borderWidth: 1,
        },
        plotOptions: {
          scatter: {
            marker: {
              radius: 5,
              states: {
                hover: {
                  enabled: true,
                  lineColor: "rgb(100,100,100)",
                },
              },
            },
            states: {
              hover: {
                marker: {
                  enabled: false,
                },
              },
            },
            tooltip: {
              headerFormat: "<b>{series.name}</b><br>",
              pointFormat: "{point.x} °C, {point.y} L/min",
            },
          },
        },
        colors: [this.colorgraph],
        // title: {
        //   text: "",
        //   align: "left",
        //   style: {
        //     color: "var(--text-color-2)",
        //     fontSize: "18px",
        //     "font-weight": "900",
        //   },
        // },
        series: [
          {
            name: "Female",
            color: "rgba(223, 83, 83, .5)",
            data: [
              [161.2, 51.6],
              [167.5, 59.0],
            ],
          },
        ],
      },
    };
  },
  async mounted() {
    // let res = await this.$API.get(`hino/getchart/${this.id}`);
    // console.log("hino/getchart scetter", res);

    // this.dataChart = [];

    // if (this.header == 'upper') {
    //   for (let i = 0; i < res.data.timestamp.length; i++) {
    //     this.dataChart.push([Number(res.data.temp_up[i]),Number(res.data.flow_up[i])])
    //   }
    // }else{
    //   for (let i = 0; i < res.data.timestamp.length; i++) {
    //     this.dataChart.push([Number(res.data.temp_down[i]),Number(res.data.flow_down[i])])
    //   }
    // }
    console.log("dataA", this.dataChart);
    await this.getDataChart();
    this.delay = 1;
  },
  methods: {
    async getDataChart() {
      let res = await this.$API.get(`hino/getchart/${this.id}`);
      console.log("hino/getchart scetter", res);
      this.dataChart = [];
      // this.dataChart12hr = [];
      if (this.header == "upper") {
        for (let i = 0; i < res.data.timestamp.length; i++) {
          this.dataChart.push([
            Number(res.data.temp_up[i]),
            Number(res.data.flow_up[i]),
          ]);
          // this.dataChart12hr.push({
          //   x: res.data.temp_up[i],
          //   y: res.data.flow_up[i],
          // });
        }
      } else {
        for (let i = 0; i < res.data.timestamp.length; i++) {
          this.dataChart.push([
            Number(res.data.temp_down[i]),
            Number(res.data.flow_down[i]),
          ]);
          // this.dataChart12hr.push({
          //   x: res.data.temp_down[i],
          //   y: res.data.flow_down[i],
          // });
        }
      }
      this.selectDataChart();
    },
    selectDataChart() {
      let newdata = [];
      if (this.select1 == 1) {
        // let index =
        //   this.dataChart12hr.length -
        //   Math.round(this.dataChart12hr.length / this.radios_hr);
        // console.log(index);
        // newdata = this.dataChart12hr.slice(index);
        // console.log("newdata", newdata.length);
        // this.datascatter.datasets[0].data = newdata;
        // // console.log(this.datascatter.datasets[0].data);

        let index =
          this.dataChart.length -
          Math.round(this.dataChart.length / this.radios_hr);
        console.log(index);
        newdata = this.dataChart.slice(index);
        this.optionChart.series = [
          {
            name: "Surface Temp, Flow Rate ",
            data: newdata,
            tooltip: {
              valueDecimals: 2,
            },
          },
        ];

        this.textSelect =
          this.options1[this.select1 - 1].text +
          " " +
          (this.radios_hr == 4 ? "3hr" : this.radios_hr == 2 ? "6hr" : "12hr");
      } else {
        this.getDataChartbyTime();
      }
    },
    async getDataChartbyTime() {
      console.log(this.dateRange);
      let body = {
        id: String(this.id),
        start: this.$moment(this.dateRange.start).format("YYYY-MM-DD HH:mm:ss"),
        end: this.$moment(this.dateRange.end).format("YYYY-MM-DD HH:mm:ss"),
      };
      let res = await this.$API.post("hino/getchartbytime", body);
      console.log("hino/getchartbytime", res);
      this.dataChartbytime = [];
      if (this.header == "upper") {
        for (let i = 0; i < res.data.timestamp.length; i++) {
          // this.dataChartbytime.push({
          //   x: res.data.temp_up[i],
          //   y: res.data.flow_up[i],
          // });
          this.dataChartbytime.push([
            Number(res.data.temp_up[i]),
            Number(res.data.flow_up[i]),
          ]);
        }
      } else {
        for (let i = 0; i < res.data.timestamp.length; i++) {
          // this.dataChartbytime.push({
          //   x: res.data.temp_down[i],
          //   y: res.data.flow_down[i],
          // });
          this.dataChartbytime.push([
            Number(res.data.temp_down[i]),
            Number(res.data.flow_down[i]),
          ]);
        }
      }
      // this.datascatter.datasets[0].data = this.dataChartbytime;

      this.optionChart.series = [
        {
          name: "Surface Temp, Flow Rate ",
          data: this.dataChartbytime,
          tooltip: {
            valueDecimals: 2,
          },
        },
      ];

      this.textSelect =
        this.options1[this.select1 - 1].text +
        " " +
        body.start +
        " - " +
        body.end;
    },
    accept() {
      console.log("aceept");
      this.selectDataChart();
      this.$refs["settingChart" + this.header].hide();
    },
    closeModal() {
      this.$refs["settingChart" + this.header].hide();
    },
    showModal() {
      this.$refs["settingChart" + this.header].show();
      // this.$bvModal.show("settingChart" + this.header)
    },
  },

  computed: {
    ScatterChartCom() {
      console.log("ScatterChartCom", this.dataChart.length);
      console.log(this.select1, this.radios_hr);
      // console.log(document.getElementById('stock-chart'+this.idgraph));
      let newdata = [];
      if (this.select1 == 1) {
        let index =
          this.dataChart.length -
          Math.round(this.dataChart.length / this.radios_hr);
        console.log(index);
        newdata = this.dataChart.slice(index);
      }
      console.log("newdata", newdata.length);
      this.optionChart.series = [
        {
          name: "Surface Temp, Flow Rate ",
          data: newdata,
          tooltip: {
            valueDecimals: 2,
          },
        },
      ];
      console.log("optionChart", this.optionChart);

      return this.optionChart;
    },
  },
};
</script>

<style  lang="scss"  scoped>
.btnBorderpop {
  border-radius: 20px;
  width: 80px;
}
#selectitem {
  display: flex;
  align-items: center;
}
#selectitem a {
  font-size: 0.85rem;
  color: rgba(0, 0, 0, 0.6);
}
.select-date {
  display: flex;
  align-items: center;
  color: #808080;
  flex-wrap: wrap;
  .date-range {
    display: flex;
    align-items: center;
    gap: 5px;
    border: 1px #808080 solid;
    border-radius: 30px;
    padding: 8px;
    background-color: #fff;
  }
}
</style>